/**
 * Vietnamese (vi-VN) - PLACEHOLDER
 * TODO Phase F+: 待越南市場啟動時翻譯
 * 當前 fallback 到 en-US，避免缺譯報錯
 */
export default {
  layout: {
    brand: 'CardShop Kiosk',
    loading: 'Loading, please wait…',
    offline: 'Network connection lost',
  },
  error: {
    network: 'Network connection failed. Please check your network settings.',
    unknown: 'An unknown error occurred. Please contact staff.',
    maintenance: 'System maintenance in progress. Please wait.',
  },
  common: {
    btn: {
      confirm: 'Confirm',
      cancel: 'Cancel',
      retry: 'Retry',
      copy: 'Sao chép',
    },
  },
  home: {
    welcome: 'Welcome to CardShop Kiosk',
    start: '開始購卡 / Start',
    startAria: 'Tap to start shopping',
    allCategories: 'All',
  },
  products: {
    title: '選擇商品 / Select Product',
    back: 'Back',
    lowStock: 'Low Stock',
    outOfStock: 'Sold Out',
    empty: 'No products available',
    loading: 'Loading products…',
    createOrderFailed: 'Failed to create order. Please try again.',
    activeOrderExists: 'You have an unfinished order. Please complete or wait for it to expire.',
    activeOrderExistsRedirecting: 'Active order detected, redirecting…',
  },
  order: {
    title: '訂單詳情 / Order Detail',
    back: 'Back',
    payNow: '前往付款 / Pay Now',
    cancel: '取消訂單 / Cancel',
    notFound: 'Order not found. Please try again.',
    cancelComingSoon: 'Order cancellation will be available in the next release.',
    status: {
      PENDING: 'Pending',
      IN_PAY: 'Paying',
      PAYING: 'Paying',
      PAID: 'Paid',
      DELIVERING: 'Delivering',
      COMPLETED: 'Completed',
      FAILED: 'Failed',
      CANCELLED: 'Cancelled',
      CANCELED: 'Cancelled',
      FULFILLED: 'Delivered',
      TIMEOUT: 'Timed Out',
      REFUNDING: 'Refunding',
      REFUNDED: 'Refunded',
    },
    paidAt: 'Payment Time',
    createdAt: 'Creation Time',
    unitPrice: 'Unit Price',
    paidAmount: 'Paid Amount',
    statusLabel: 'Status',
    cardNumber: 'Card Number',
    cardKey: 'Card Key',
    invoice: 'Invoice',
    invoiceNo: 'Invoice No.',
    invoiceIssued: 'Issued',
    invoiceApply: 'Request Invoice',
    invoiceApplyTitle: 'Request E-Invoice',
    invoiceCarrierType: 'Carrier Type',
    invoiceCarrierNone: 'None (Cloud Storage)',
    invoiceCarrierMobile: 'Mobile Barcode',
    invoiceCarrierCDC: 'Carrier Number',
    invoiceCarrierEZ: 'EasyCard / icash',
    invoiceCarrierEmail: 'Email',
    invoiceCarrierDonation: 'Donate Invoice',
    invoiceCarrierId: 'Carrier ID',
    invoiceCarrierIdPlaceholder: 'Enter carrier ID',
    invoiceEmail: 'Email',
    invoiceEmailPlaceholder: 'Enter email address',
    invoiceDonationHint: 'Invoice will be donated to Eden Social Welfare Foundation (Code: 25885)',
    invoiceSubmit: 'Submit',
    invoiceSubmitting: 'Submitting...',
    invoiceSuccess: 'Invoice requested! Invoice No.: {no}',
    invoiceSuccessDonation: 'Thank you for your donation! Invoice donated to Eden Social Welfare Foundation',
    invoiceFailed: 'Failed to request invoice, please retry',
    invoiceDuplicate: 'An invoice has already been issued for this order',
    invoiceAutoSubmit: 'Donate & Close ({seconds}s)',
    invoiceAutoSubmitDone: 'Invoice auto-donated',
    processSteps: 'Process Steps',
    redeemInfo: 'Thông tin đổi thẻ',
    processing: 'Processing...',
    loadingPayload: 'Retrieving card info, please wait…',
    retryPayload: 'Retry fetching card info',
    payloadLoaded: 'Card info retrieved',
    payloadFailed: 'Failed to retrieve card info, please retry',
    statusLoading: 'Loading…',
    copySuccess: 'Đã sao chép',
    copyFailed: 'Sao chép thất bại, vui lòng sao chép thủ công',
    sendCardEmail: 'Gửi mã thẻ qua email',
    sendCardEmailTitle: 'Gửi mã thẻ qua email',
    sendCardEmailHint: 'Số thẻ và mã thẻ sẽ được gửi đến email bạn nhập. Vui lòng kiểm tra địa chỉ email.',
    sendCardEmailInput: 'Nhập địa chỉ email',
    sendCardEmailSubmit: 'Gửi',
    sendCardEmailSending: 'Đang gửi...',
    sendCardEmailSuccess: 'Đã gửi mã thẻ, vui lòng kiểm tra email',
    sendCardEmailFailed: 'Gửi thất bại, vui lòng thử lại',
    qrVerifyTitle: 'Mã QR xác minh',
    qrVerifyHint: 'Thương nhân quét để xác minh thẻ này đã được phát hành từ máy chưa',
    qrVerifyLoading: 'Generating QR code…',
    qrVerifyRetry: 'Retry QR code',
    customerContact: 'Customer Support',
    customerContactNone: 'Please contact staff if you need assistance',
    customerContactTitle: 'Liên hệ hỗ trợ',
    customerContactClose: 'Đóng',
  },
  ad: {
    exitTip: 'Touch screen to exit',
  },
  maintenance: {
    title: '設備維護中 / Under Maintenance',
    retry: 'Retry Connection',
    network_offline: 'Network connection lost. Please check your network.',
    auth_failed: 'Device authentication failed. Please contact support.',
    machine_locked: 'Device has been remotely locked.',
    dtu_offline: 'Card dispenser is offline. Waiting for recovery.',
    unknown: 'An unknown system error has occurred.',
    reconnecting: 'Attempting to reconnect…',
    wsStatus: 'WS Connection Status',
    networkOnline: 'Network Online',
    networkOffline: 'Network Offline',
    contactTitle: 'Contact Support',
    contactPhoneLabel: 'Hotline',
    contactPhone: '400-888-0000',
    contactWechat: '@cardshop_support',
    workOrder: 'Submit ticket: support.cardshop.com',
  },
  pay: {
    title: 'Payment',
    summary: 'Order Summary',
    orderPayment: 'Thanh toán đơn hàng',
    method: 'Payment Method',
    cash: 'Cash',
    linepay: 'LinePay',
    card: 'Credit Card',
    applepay: 'Apple Pay',
    comingSoon: 'This payment method is coming soon',
    insertBill: 'Please insert banknotes',
    remaining: 'Remaining',
    completed: 'Payment Complete!',
    cancelled: 'Payment Cancelled',
    billReceived: '{amount} received',
    billInsertedFull: 'Đã nạp {inserted}',
    billInsertedStatus: 'Đã nạp {inserted}, còn lại {remaining}',
    contactSupport: 'Contact Support',
    cancelOrder: 'Cancel Order',
    timeout: 'No activity detected. Please complete payment soon.',
    orderNotFound: 'Order not found. Please place a new order.',
    fullyPaidRedirect: 'Payment complete. Redirecting…',
    // ── F.12 new: change / bill rejected / timeout ───────────────────────────
    change: {
      label: 'Vui lòng lấy tiền thối {amount}',
    },
    billRejected: 'Máy tạm thời không đọc được tiền, vui lòng thử lại. Liên hệ nhân viên nếu vẫn lỗi.',
    billTimeout: 'Hết thời gian bỏ tiền, đơn hàng đã bị hủy. Vui lòng chọn lại sản phẩm.',
    countdown: 'Vui lòng bỏ tiền trong vòng {time}. Đơn hàng sẽ bị hủy khi hết thời gian.',
    countdownExpired: 'Đơn hàng đã hết thời gian. Vui lòng đặt hàng mới.',
  },
  toast: {
    dismiss: 'Dismiss',
  },
  header: {
    online: 'Online',
    offline: 'Offline',
    reconnecting: 'Reconnecting',
  },
  footer: {
    online: 'Network OK',
    offline: 'Network Down',
    reconnecting: 'Network Reconnecting',
  },
}
